// import React from 'react';
// import { useLanguage } from '../contexts/LanguageContext';

// export const Footer = () => {
//   const { t } = useLanguage();

//   return (
//     <footer className="bg-gray-900 text-gray-300 mt-16" data-testid="footer">
//       <div className="max-w-7xl mx-auto px-4 md:px-8 py-12">
//         <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
//           {/* Brand */}
//           <div className="md:col-span-2">
//             <div className="flex items-center gap-2 mb-4">
//               <div className="w-10 h-10 bg-[#0052CC] rounded-lg flex items-center justify-center">
//                 <span className="text-white font-bold text-lg">M</span>
//               </div>
//               <span className="font-heading font-bold text-xl text-white">GIZI.AI</span>
//             </div>
//             <p className="text-sm text-gray-400 max-w-md">
//               Temukan produk terbaik dari toko-toko terdekat di sekitar Anda. Belanja mudah, cepat, dan aman.
//             </p>
//           </div>

//           {/* Links */}
//           <div>
//             <h4 className="font-heading font-semibold text-white mb-4">{t('about_us')}</h4>
//             <ul className="space-y-2 text-sm">
//               <li><a href="#" className="hover:text-white transition-colors">{t('about_us')}</a></li>
//               <li><a href="#" className="hover:text-white transition-colors">{t('contact')}</a></li>
//               <li><a href="#" className="hover:text-white transition-colors">{t('help')}</a></li>
//             </ul>
//           </div>

//           {/* Legal */}
//           <div>
//             <h4 className="font-heading font-semibold text-white mb-4">Legal</h4>
//             <ul className="space-y-2 text-sm">
//               <li><a href="#" className="hover:text-white transition-colors">{t('privacy_policy')}</a></li>
//               <li><a href="#" className="hover:text-white transition-colors">{t('terms')}</a></li>
//             </ul>
//           </div>
//         </div>

//         <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-500">
//           <p>&copy; {new Date().getFullYear()} GIZI.AI . All rights reserved.</p>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;

import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-gray-900 text-gray-300 mt-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <img
                src="https://kontentutorialmpstore-cdn.maduraprime.com/85e24262-ce3a-4e64-8c4d-82f74f0f3afe.png"
                alt="GIZI.AI Logo"
                className="w-10 h-10 object-contain"
              />
              <div className="flex flex-col">
                <span className="font-heading font-bold text-xl text-white leading-tight">
                  GIZI.AI
                </span>
                <span className="text-[10px] text-gray-400 font-medium -mt-0.5">
                  by Kadin Indonesia
                </span>
              </div>
            </div>
            <p className="text-sm text-gray-400 max-w-md">
              Gizi.Ai memfasilitasi pengadaan bahan pangan berkualitas untuk Program SPPG / Makan Bergizi Gratis, mendukung pemenuhan gizi nasional bersama Kadin Indonesia.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4">{t('about_us')}</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="hover:text-white transition-colors">{t('about_us')}</a></li>
              <li><a href="#" className="hover:text-white transition-colors">{t('contact')}</a></li>
              <li><a href="#" className="hover:text-white transition-colors">{t('help')}</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="hover:text-white transition-colors">{t('privacy_policy')}</a></li>
              <li><a href="#" className="hover:text-white transition-colors">{t('terms')}</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-500">
          <p>&copy; {new Date().getFullYear()} GIZI.AI. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;